import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useStaffModel } from "../staffModel"
import { DetailType } from "../../../../types/ScmEnums"
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const DataBox = () => {
    const {
        selectedRowKeys,
        detailDrawer: visible,
        loadData,
        setDetailDrawer,
        setDetailType,
    } = useStaffModel()
    const onAdd = () => {
        setDetailDrawer(!visible)
        setDetailType(DetailType.add)
    }
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        setDetailDrawer(!visible)
        setDetailType(DetailType.edit)
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        setDetailDrawer(!visible)
        setDetailType(DetailType.look)
    }

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >{Locale["Add"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >{Locale["Edit"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onLook}
        >{Locale["View"]}</Button>
    </>
    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}